import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inventaire__right" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "filtre",
    src: "/wp-content/themes/theme_central/img/filtrer.svg"
  })
], -1)
const _hoisted_3 = { class: "inventaire__right__header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "List",
    src: "/wp-content/themes/theme_central/img/list.svg"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Grid",
    src: "/wp-content/themes/theme_central/img/grille.svg"
  })
], -1)
const _hoisted_6 = { class: "select" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "select__arrow" }, null, -1)
const _hoisted_9 = { class: "active-filter__container" }
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  id: "loading",
  class: "inventaire__loading-content"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "inventaire__loading-spin" }, null, -1)
const _hoisted_13 = { class: "size__h3" }
const _hoisted_14 = {
  key: 0,
  class: "inventaire__notice",
  id: "messageRechercheVehicule"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "inventaire__notice",
  id: "messageAucunVehicule",
  style: {"display":"none"}
}
const _hoisted_17 = {
  key: 3,
  id: "messageRefer"
}
const _hoisted_18 = {
  key: 4,
  id: "inventairePagination"
}
const _hoisted_19 = { class: "inventaire__pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resetActiveFilter = _resolveComponent("resetActiveFilter")!
  const _component_activeFilter = _resolveComponent("activeFilter")!
  const _component_cardItem = _resolveComponent("cardItem")!
  const _component_paginatorComponent = _resolveComponent("paginatorComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["inventaire__right__position", {inventaire__right__position_fixed: _ctx.state.scrollPosition > _ctx.inventairePosition(200)}]),
      id: "position",
      style: _normalizeStyle([_ctx.state.isOpen ? 'display: none' : '' ])
    }, [
      _createElementVNode("div", {
        class: "inventaire__right__view-cnt",
        id: "filtre",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFilter()))
      }, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.state.jsonFile['action']['filterSearch']), 1)
      ])
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.state.isOpen ? 'inventaire__right__content-none' : 'inventaire__right__content' ])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          id: "invList",
          class: _normalizeClass('inventaire__right__view-cnt' + [!_ctx.state.switchDisplay ? ' inventaire__right__view-cnt-active' : '']),
          style: _normalizeStyle([_ctx.state.switchDisplay ? '' : 'pointer-events:none;']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchCards('view_list')))
        }, [
          _hoisted_4,
          _createElementVNode("p", null, _toDisplayString(_ctx.state.jsonFile['action']['viewList']), 1)
        ], 6),
        _createElementVNode("div", {
          id: "invGrille",
          class: _normalizeClass('inventaire__right__view-cnt' + [_ctx.state.switchDisplay ? ' inventaire__right__view-cnt-active' : '']),
          style: _normalizeStyle([!_ctx.state.switchDisplay ? '' : 'pointer-events:none;']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchCards('view_grid')))
        }, [
          _hoisted_5,
          _createElementVNode("p", null, _toDisplayString(_ctx.state.jsonFile['action']['viewGrid']), 1)
        ], 6),
        _createElementVNode("label", null, _toDisplayString(_ctx.state.jsonFile['filtre']['orderBy']), 1),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            name: "ordre",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.filter.order) = $event)),
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePage(1)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.jsonFile['filtre']['orderByList'], (order) => {
              return (_openBlock(), _createElementBlock("option", {
                key: order.id,
                value: order.id
              }, _toDisplayString(order.name), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.state.filter.order]
          ]),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.state.activeFilters.length >= 1)
          ? (_openBlock(), _createBlock(_component_resetActiveFilter, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.jsonFile['activeFilter'], (activeFilter) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: activeFilter.id
          }, [
            (_ctx.state.activeFilters.indexOf(activeFilter.id) >= 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "active-filter",
                  title: activeFilter.title
                }, [
                  (activeFilter.type == 'range')
                    ? (_openBlock(), _createBlock(_component_activeFilter, {
                        key: 0,
                        type: activeFilter.type,
                        locale: _ctx.state.locale,
                        group: activeFilter.group,
                        name: activeFilter.group,
                        title: activeFilter.title,
                        invalid: _ctx.state.invalidList.findIndex(item => item.replace(/(min|max)/, '').toLowerCase() === activeFilter.name) >= 0,
                        format: activeFilter.format,
                        value: { 'min': _ctx.state.filter['min' + _ctx.ucFirst(activeFilter.name)], 'max': _ctx.state.filter['max' + _ctx.ucFirst(activeFilter.name)] }
                      }, null, 8, ["type", "locale", "group", "name", "title", "invalid", "format", "value"]))
                    : (_openBlock(), _createBlock(_component_activeFilter, {
                        key: 1,
                        type: activeFilter.type,
                        locale: _ctx.state.locale,
                        group: activeFilter.group,
                        name: activeFilter.name,
                        invalid: _ctx.state.invalidList.findIndex(item => item.toLowerCase() === activeFilter.name.toLowerCase()) >= 0,
                        format: activeFilter.format,
                        value: _ctx.state.filter[activeFilter.name]
                      }, null, 8, ["type", "locale", "group", "name", "invalid", "format", "value"]))
                ], 8, _hoisted_10))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.state.jsonFile['action']['loading']), 1)
      ]),
      (_ctx.state.invalidList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(_ctx.state.jsonFile['message']['noResult'][0]), 1),
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.state.jsonFile['message']['noResult'][1]), 1)
            ])
          ]))
        : (Number(_ctx.state.nbCars) == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.state.jsonFile['message']['match']['nothing']), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([_ctx.state.switchDisplay ? 'inventaire__right__grid' : 'inventaire__right__grid inventaire__right__grid-list'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.data, (vehicule) => {
                return (_openBlock(), _createBlock(_component_cardItem, {
                  defaultImg: '//'+_ctx.serverPhotoPath+'/1024/'+_ctx.defaultImg,
                  route: _ctx.state.jsonFile['route']['vehicule'],
                  key: vehicule['vehicule_gvo_id_i'],
                  id: vehicule['vehicule_gvo_id_i'],
                  image: '//'+_ctx.serverPhotoPath+'/1024/'+vehicule['vehicule_photo_t'],
                  instavid: vehicule['vehicule_instavid_spin_s'],
                  carfax: '//'+_ctx.serverPhotoPath+'/'+vehicule['marchand_site_theme_image_carfax_path_s'],
                  category: vehicule['vehicule_sous_modele_valide_s'],
                  price: vehicule['vehicule_prix_d'],
                  discount: vehicule['vehicule_rabais_d'],
                  brand: vehicule['vehicule_marque_nom_s'],
                  model: vehicule['vehicule_modele_s'],
                  year: vehicule['vehicule_annee_i'],
                  type: vehicule['vehicule_type_i'],
                  stringify: _ctx.vehiculeStringify(vehicule['vehicule_marque_nom_s'], vehicule['vehicule_modele_s'], vehicule['vehicule_annee_i']),
                  financement: _ctx.calculFinancement(vehicule),
                  odo: vehicule['vehicule_km_i'],
                  fuel: vehicule['vehicule_carburant_nom_s'],
                  traction: vehicule['vehicule_transmission_s']
                }, null, 8, ["defaultImg", "route", "id", "image", "instavid", "carfax", "category", "price", "discount", "brand", "model", "year", "type", "stringify", "financement", "odo", "fuel", "traction"]))
              }), 128))
            ], 2)),
      (Number(_ctx.state.nbCars) > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.state.jsonFile['message']['refer']), 1))
        : _createCommentVNode("", true),
      (Number(_ctx.state.nbCars) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pagesList, (page) => {
                return (_openBlock(), _createBlock(_component_paginatorComponent, {
                  key: page,
                  value: page,
                  selectedValue: _ctx.state.filter.currentPage.toString(),
                  onClick: ($event: any) => (_ctx.changePage(page))
                }, null, 8, ["value", "selectedValue", "onClick"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}